/**
 * This is a compiled JS file.
 * Changes here could be overwritten. 
 * Contact your Shopify developers if changes need to be made.
 */

// document.addEventListener('DOMContentLoaded', function() {
//     var stickyForm = document.querySelector('.product-single__form');
//     var stickyFormOffset = stickyForm.offsetTop;

//     function stickForm() {
//         if (window.pageYOffset >= stickyFormOffset) {
//             stickyForm.parentNode.classList.add('parent-sticky');
//             stickyForm.classList.add('sticky');
//         } else {
//             stickyForm.parentNode.classList.remove('parent-sticky');
//             stickyForm.classList.remove('sticky');
//         }
//     }

//     stickForm(); // Run it once on page load

//     window.addEventListener('scroll', stickForm);
// });


document.addEventListener('DOMContentLoaded', function() {
    var stickyForm = document.querySelector('.product-single__form');
    var parentContainer = stickyForm.parentNode;
    var stickyFormOffset = stickyForm.offsetTop;
    var stickyFormHeight = stickyForm.offsetHeight;

    function adjustParentHeight() {
        parentContainer.style.height = stickyFormHeight + 'px';
    }

    function stickForm() {
        if (window.pageYOffset >= stickyFormOffset) {
            adjustParentHeight();
            stickyForm.classList.add('sticky');
        } else {
            parentContainer.style.height = 'auto'; // Reset parent container height
            stickyForm.classList.remove('sticky');
        }
    }

    stickForm(); // Run it once on page load

    window.addEventListener('scroll', stickForm);
});
